const $ = window.$;
const numberOnlyRegEx = /^[0-9]*$/;
function checkID(id) {
    if (id.length !== 13) return false;
    let sum = 0;
    for (let i = 0; i < 12; i++) {
        sum += parseFloat(id.charAt(i)) * (13 - i);
    }
    if ((11 - sum % 11) % 10 !== parseFloat(id.charAt(12)))
        return false;
    return true;
}

function IsValidMobilePhone(phonenumber) {
    return /0[13456789]{1}[0-9]{8}$/.test(phonenumber)// && /^0[869]/.test(phonenumber);
}

function IsNumberOnly(str) {
    return /[0123456789]$/.test(str)
}

function IsPostCode(str) {
    let valid = true
    valid = valid && !(/(\d)\1\1\1\1/.test(str))
    valid = valid && IsNumberOnly(str)
    return valid
}

export function validatePlaceName(str) {
    let valid = true
    valid = valid && (str.length !== 1 && str[0] !== ' ' && str.indexOf('|') === -1)
    valid = valid && !(/[^0-9A-Za-z\~!@#$%&*()_+=\u002D\u0027\\\][{}\:;\/?.><, \u0E01-\u0E3A\u0E40-\u0E4D\^]/.test(str))
    return valid
}

export function toThousandSeparated(num) {
    if (num === '') {
        return '';
    }

    num = '' + num;

    var isNegative = num.indexOf('-') === 0;
    var output = isNegative ? num.slice(1) : num;
    var count = 0;
    var i = output.length - 1;

    while (i > 0) {
        count++;

        if (count >= 3) {
            output = output.slice(0, i) + ',' + output.slice(i);
            count = 0;
        }

        i--;
    }

    return (isNegative ? '-' : '') + output;
}

export function getAmount(value) {
    return value.trim().replace(RegExp(',', 'g'), '');
}

function isInteger(val) {
    return /^[0-9]*$/.test(val);
}

export function VaridateCalcDataField(formData, field, value) {
    if (typeof (value) == 'boolean') {
        value = value.toString();
    }

    const formDataField = formData[field];

    switch (field) {
        case 'stayInstallmentYear':
            value = getAmount(value);

            if (value === '') {
                return 'กรุณากรอกระยะเวลาผ่อนชำระ';
            }

            return '';
        case 'stayPropertyLimitAmount':
            value = getAmount(value);

            if (value === '') {
                return 'กรุณากรอกวงเงินทรัพย์';
            }

            return '';
        case 'stayDecorationLimitAmount':
            value = getAmount(value);

            if (value === '') {
                return 'กรุณากรอกวงเงินตกแต่ง';
            }

            return '';
        case 'stayIncomePerMonth':
            value = getAmount(value);

            if (value === '') {
                return 'กรุณากรอกรายได้ต่อเดือน';
            } else if (+value < formDataField.minValue) {
                return 'ผู้กู้ต้องมีรายได้ขั้นต่ำ ' + toThousandSeparated('' + formDataField.minValue) + ' บาท';
            }

            return '';
        case 'stayDebtBurdenPerMonth':
            value = getAmount(value);

            if (value === '') {
                return 'กรุณากรอกภาระหนี้';
            }

            return '';
        case 'businessInstallmentYear':
            value = getAmount(value);

            if (value === '') {
                return 'กรุณากรอกระยะเวลาผ่อนชำระ';
            }

            return '';
        case 'businessPropertyLimitAmount':
            value = getAmount(value);

            if (value === '') {
                return 'กรุณากรอกวงเงินทรัพย์';
            }

            return '';
        case 'businessDecorationLimitAmount':
            value = getAmount(value);

            if (value === '') {
                return 'กรุณากรอกวงเงินตกแต่ง';
            }

            return '';
        case 'businessIncomePerMonth':
            value = getAmount(value);

            if (value === '') {
                return 'กรุณากรอกกำไรสุทธิต่อเดือน';
            }

            return '';
        case 'businessDebtBurdenPerMonth':
            value = getAmount(value);

            if (value === '') {
                return 'กรุณากรอกภาระหนี้';
            }

            return '';

        // case 'price':
        //     value = getAmount(value);

        //     if (value === '') {
        //         return 'กรุณากรอกราคาทรัพย์/ราคาเสนอซื้อ';
        //     } else if (!isInteger(value)) {
        //         return 'กรุณาระบุเป็นจำนวนเต็ม';
        //     } else if (definedPropertyPrice !== null && +value > definedPropertyPrice) {
        //         return 'กรุณาระบุราคาไม่เกิน ' + toThousandSeparated('' + definedPropertyPrice) + ' บาท';
        //     }
        //     return '';
        
        default:
            return '';
    }
}

export function VaridateDropleadDataField(formData, field, value) {
    if (typeof (value) == 'boolean') {
        value = value.toString()
    }

    const formDataField = formData[field];
    if (formDataField.required) {
        switch (field) {
            case 'juJuristicId':
                if (value === '') {
                    return 'กรุณากรอกเลขนิติบุคคล';
                } else if (!/^[0-9]{13}$/g.test(value)) {
                    return 'กรอกข้อมูลเลขนิติบุคคลให้ถูกต้อง';
                }

                return '';
            case 'juFirstName':
                if (value === '') {
                    return 'กรุณากรอกชื่อ';
                } else if (!isThaiEngNonNumber(value)) {
                    return 'กรอกข้อมูลชื่อให้ถูกต้อง';
                }

                return '';
            case 'juLastName':
                if (value === '') {
                    return 'กรุณากรอกนามสกุล';
                } else if (!isThaiEngNonNumber(value)) {
                    return 'กรอกข้อมูลนามสกุลให้ถูกต้อง';
                }

                return '';
            case 'phone':
                if (value === '') {
                    return 'กรุณากรอกเบอร์มือถือ';
                } else if (!IsValidMobilePhone(value) || !/^0[869]/.test(value)) {
                    return 'กรอกข้อมูลเบอร์มือถือให้ถูกต้อง';
                }

                return '';
            case 'confirmphone':
                var mobileNo = formData["phone"].value.trim();

                if (value === '') {
                    return 'กรุณาระบุเบอร์มือถือให้ตรงกัน';
                } else if (value !== mobileNo) {
                    return 'กรุณาระบุเบอร์มือถือให้ตรงกัน';
                }

                return '';
            case 'email':
                if (value === '') {
                    return 'กรุณากรอกอีเมล';
                } else if (!IsValidEmail(value)) {
                    return 'กรอกข้อมูลอีเมลให้ถูกต้อง';
                }

                return '';
            case 'naCitizenId':
                if (value === '') {
                    return 'กรุณากรอกเลขบัตรประชาชน';
                } else if (!checkID(value)) {
                    return 'กรอกข้อมูลเลขบัตรประชาชนให้ถูกต้อง';
                }

                return '';
            case 'consentCheck':
            case 'juCompanyName':
                if (value === '') {
                    return 'กรุณากรอกชื่อบริษัท';
                } else if (!isCompanyNameFormat(value)) {
                    return 'กรอกข้อมูลชื่อบริษัทให้ถูกต้อง';
                }

                return '';
            case 'naFirstName':
                if (value === '') {
                    return 'กรุณากรอกชื่อ';
                } else if (!isThaiEngNonNumber(value)) {
                    return 'กรอกข้อมูลชื่อให้ถูกต้อง';
                }

                return '';
            case 'naLastName':
                if (value === '') {
                    return 'กรุณากรอกนามสกุล';
                } else if (!isThaiEngNonNumber(value)) {
                    return 'กรอกข้อมูลนามสกุลให้ถูกต้อง';
                }

                return '';
            case 'naCareer':
                if (value === '') {
                    return 'กรุณากรอกอาชีพ';
                }

                return '';
            case 'naSalary':
                value = getAmount(value);

                if (value === '') {
                    return 'กรุณากรอกรายได้ต่อเดือน';
                } else if (!IsNumberOnly(value)
                    || !/^[1-9]/.test(value)
                    || getAmountDigit(value) > 7) {
                    return 'กรอกข้อมูลรายได้ต่อเดือนให้ถูกต้อง';
                }

                return '';
            case 'availableTime':
                if (value === '') {
                    return 'กรุณากรอกช่วงเวลาที่สะดวกให้ติดต่อกลับ';
                }

                return '';
            default:
                return '';
        }
    }
    else {
        return '';
    }
}

function IsValidEmail(email) {
    // the regex works in IE but should be a string (see nnnnn's answer) 
    // var em= new RegExp(/^[+a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i);
    var em = /^[+a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i; // simpler
    return em.test(email);
}

var thaiEngNonNumberRegEx = /^[A-Za-z\u0E00-\u0E5F_-]*$/;

function isThaiEngNonNumber(str) {
    return thaiEngNonNumberRegEx.test(str);
}

var companyNameRegEx = /^[A-Za-z0-9\u0E00-\u0E5F\s.,()-]*$/;
function isCompanyNameFormat(str) {
    return companyNameRegEx.test(str);
}

function getAmountDigit(num) {
    var count = 0;

    num.split("").filter(function (ch) {
        if (numberOnlyRegEx.test(ch)) {
            count++;
        }
    });

    return count;
}

export function GoToError() {
    if ($('.text-error:first').length !== 0) {
        // if(isElementOutViewport($('.text-error:first').parent()[0])){
        //     $('html, body').animate({
        //         scrollTop: $('.text-error:first').parent().offset().top
        //     }, 500);
        // }
        // $('html, body').animate({
        //     scrollTop: $('.text-error:first').parent().offset().top
        // }, 500);
        $('html, body').scrollTop($('.text-error:first').parent().offset().top - 20);
        $('.text-error:first').parent().find('input').shake()
        console.log("done goto error")
    } else {
        console.log("not found goto error")
    }
}

// function isElementOutViewport(el){
//     var rect = el.getBoundingClientRect();
//     return rect.bottom < 0 || rect.right < 0 || rect.left > window.innerWidth || rect.top > window.innerHeight;
// }